"use client";

import { FC } from "react";

import { MODALS } from "@Shared/config";
import { useModalState } from "@Shared/store";
import { Button, ButtonProps } from "@Shared/ui";

export type ButtonLetsTalkProps = ButtonProps;

export const ButtonLetsTalk: FC<ButtonLetsTalkProps> = ({ className, ...restProps }) => {
    const { open: modalOpen } = useModalState(["open"]);

    return (
        <Button className={className} variant="secondary" onClick={() => modalOpen(MODALS.getInTouch)} {...restProps}>
            Let’s Talk!
        </Button>
    );
};
